import { Directive, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { ViewportService } from 'src/app/core/helpers/viewport.service';

@Directive({
  selector: '[ifDesktop]'
})
export class IfDesktopDirective implements OnInit, OnDestroy {
  private subscription: Subscription;
  private hasView = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private viewportService: ViewportService
  ) { }

  ngOnInit(): void {
    this.subscription = this.viewportService.isMobile$.subscribe((isMobile: boolean) => {
      this.updateView(!isMobile);
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private updateView(showDesktopView: boolean): void {
    if (showDesktopView && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
      return;
    }

    if (!showDesktopView && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
